import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import SideBar from "../components/Sidebar";
import { SidebarProvider } from "../content/SidebarContent";
import Header from "./Header";

const MainLayout = () => {
  // new structure

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsSidebarOpen(true);
      }
    };
    handleResize(); // run on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <SidebarProvider>
      {/* <div className="main-layout h-screen flex flex-col">
        <div className="flex flex-1 container main-layout-wrapper relative">
          <SideBar />
          <div className="flex-1 flex flex-col relative overflow-auto">
            <Outlet />
            <Footer />
          </div>
        </div>
      </div> */}
      {/* new structure  */}
      <div className="flex h-screen bg-gray-100">
        <SideBar
          isOpen={isSidebarOpen}
          toggleSidebar={() => setIsSidebarOpen((prev) => !prev)}
        />

        <div
          className={`flex-1 flex flex-col transition-all duration-300 ${isSidebarOpen ? "w-[calc(100%-265px)]" : "w-[calc(100%-80px)]"
            }`}
        >
          <Header toggleSidebar={() => setIsSidebarOpen((prev) => !prev)} isOpen={isSidebarOpen} />
          <main
            className="flex-1 overflow-y-auto scroll-none py-6 px-3 sm:sm:p-6 overflow-x-hidden p-3 bg-[#fff] min-w-0 w-full" 
          >
            <Outlet context={{ isSidebarOpen }}/>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default MainLayout;
